import { useHookstate } from "@hookstate/core"
import { getDateOnly, onInputChangeNative, showSnackbar } from "../../../misc/utils";
import InputField from "../../../components/input-field/InputField";
import DefaultButton from "../../../components/default-button/DefaultButton";
import Plus from "../../../assets/icons/Plus";
import Modal from "../../../components/Modal/Modal";
import { useNewUniversalFind, useUniversalFind } from "../../../hooks/universal";
import { certificatesTableColumns, examTableColumns } from "../../../misc/constants";
import { Exam } from "../../../types";
import CalendarTime from "../../../assets/icons/CalendarTime";
import { simpleGetter } from "../../../actions/common";
import { CARTERA_API_HOST, certificateApi, examApi } from "../../../api/api";
import { accessGlobalUserState } from "../../../stores/user";
import { Avatar } from "../../../components/Avatar";
import tickWhite from "../../../assets/svg/tick-white.svg";

export const Certificates = () => {
    const userState = accessGlobalUserState().get()
    const localState = useHookstate({
        mainUserCertificatesTriggerFetch: 0
    })
    const state = localState.get()
    const { mainUserCertificatesTriggerFetch } = state

    const mainUserCertificates: any[] = useUniversalFind('MainUserCertificate', {
        status: 1
    }, { include: ['certificate', 'student'] }, mainUserCertificatesTriggerFetch)

    const signMainUserCertificate = (c: any) => async () => {
        const response = await simpleGetter(certificateApi.signMainUserCertificate, {
            main_user_certificate_id: c.id
        })
        if (response.success) {
            showSnackbar('Успешно', 'success');
            localState.mainUserCertificatesTriggerFetch.set(mainUserCertificatesTriggerFetch + 1)
        }
    }

    return (
        <div className="flex flex-col h-full p-8 overflow-y-auto">
            <div className="flex flex-col flex-1 gap-4 p-4 bg-white rounded-xl">
                <div className="flex flex-row gap-8 justify-between">
                </div>
                <div className="flex flex-col flex-1 overflow-y-auto">
                    <table className="table-auto lesson-students-table">
                        <thead>
                            <tr className="text-valley-black">
                                {certificatesTableColumns.map(c => (
                                    <td>
                                        <span>{c}</span>
                                    </td>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="text-valley-black">
                            {mainUserCertificates.map((c, i) => (
                                <tr>
                                    <td>
                                        <div className="flex items-center gap-2">
                                            <Avatar user={c.student} />
                                            <span>
                                                {c.student.json_saved_data.firstname} {c.student.json_saved_data.lastname}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <span>
                                            {c.certificate.name}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {getDateOnly(c.createdAt)}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="flex flex-col gap-2">
                                            <button
                                                className={`flex-1 py-3 rounded-lg flex flex-row justify-center items-center bg-[#3BBC30]`}
                                                onClick={signMainUserCertificate(c)}
                                            >
                                                <img src={tickWhite} />
                                                <span className="ml-2 font-bold text-[15px] text-white">
                                                    Одобрить
                                                </span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}